import { every, go, isNil, mapL, negate } from "fxjs/es";
export const getIsAllGridExisting = (self) =>
  go(
    self._grids.values(),
    mapL(({ target_image_el }) => target_image_el),
    every(negate(isNil))
  );
